function NoPage(){
    return (
      <>
      <h1 className="flex justify-center align-middle mt-60">This NoPage</h1>
      </>
    )
  }
  
export default NoPage;